import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-date-interval',
  templateUrl: './date-interval.component.html',
  styleUrls: ['./date-interval.component.scss']
})
export class DateIntervalComponent implements OnInit {

  @Input() inicio = new Date();
  @Input() fim = new Date();

  @Output() inicioChange = new EventEmitter();
  @Output() fimChange = new EventEmitter();

  formatInicio;
  formatFim;
  constructor() {}

  ngOnInit() {

    this.formatInicio = this.toComponentFormat(this.inicio);
    this.formatFim = this.toComponentFormat(this.fim);
  }


  toComponentFormat(date: Date) {
    return { year: date.getFullYear(), month: date.getMonth() +1, day: date.getDate() }
  }

  toDate(date: {year:number,month:number,day:number,hour?:number,minute?:number,second?:number}) {
    return new Date(
      date.year,
      date.month - 1,
      date.day,
      date.hour || 0,
      date.minute || 0,
      date.second || 0
    )
  }

  setInicio(date, dinicio) {
    dinicio.close(); dinicio.close();
    dinicio._elRef.nativeElement.blur()
    this.formatInicio = date;
    this.inicio = this.toDate(this.formatInicio);
    this.inicioChange.emit(this.inicio);
  }

  setFim(date, dfim) {
    dfim.close(); dfim.close();
    dfim._elRef.nativeElement.blur()
    this.formatFim = date;
    this.fim = this.toDate({...this.formatFim, hout: 23, minute: 59, second: 59 });
    this.fimChange.emit(this.fim);
  }


}
